import React from 'react';
import './css/advertiser.css';
import './css/styles.css';

import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';



class Advertisers extends React.Component{
    render(){
        return(   
            <div>
                <Helmet>
                <title>{this.props.value.title}</title>
                <meta
                    property="og:title"
                    content={this.props.value.title}
                />

                <meta
                    property="og:description"
                    content={this.props.value.description}
                />
                  <meta
                    property="og:url"
                    content={window.location.href}
                />
                <link rel="canonical" href={window.location.href} />
                <link rel="alternate" hreflang="en-in" href={window.location.href} />

            </Helmet>
                
<div style={{position:'relative',paddingTop:'80px'}}>
    <img src="/assets/images/aiplex-ads-advertisers.png" alt="advertisers"  title="Advertisers" className="landing_img1"/>
    <div className="landing_text1">
        <h1 className="corporate ltext">
            <span className="first-letter">A</span>DVERTISERS
        </h1>
    </div>

    <div className="bcdiv">
          <div className=" row">
          <td className="bchome">
          <a href="/" className="pl-1 bchome">Home</a>
          </td>
          <i className="bctext fa fa-angle-double-right pl-2" aria-hidden="true"></i>
          <td className="bcblue">
          <a href="/advertisers" className="pl-2 bcblue">Advertiser</a>
          </td>
          </div>
        </div>
</div>
<div className="hrline"></div>
<div className="Banner_BG1">
    <div className="Banner_padding_adv">
       
        <div className="row pt-5">

            <div className="col-sm-6 pr-5 ">
                <p className="text-justify p16">Our platform enables you to partner with a diverse range of publishers; content sites, influencers, website owners, technology partners, cashback, coupon companies, etc. You get to choose the right partner to target the right audience.
                </p>
                <img src="/assets/images/aiplex-ads-more-control.png" alt="More control for Advertisers to GrowTheir Businesses"  title="More control for Advertisers to GrowTheir Businesses" className="img_size pt-4"/>
            </div>
            <div className="col-sm-6 pl-5 my-auto">
                <div>
                    <h3 className="corporate h3f"><span className="first-letter">C</span>onnect</h3>
                    <p className="p16" >Our platform connects advertisers to a wide network of affiliate partners across the globe.
                    </p>
                    <img src="/assets/images/hrline.png" alt="horizontal line"  title="horizontal line" width="100%"/>
                </div>
                <div className="pt-3">
                    <h3 className="corporate h3f"><span className="first-letter">T</span>rust</h3>
                    <p className="p16" >An in-depth screening process while approving publishers to build trust.
                    </p>
                    <img src="/assets/images/hrline.png" alt="horizontal line"  title="horizontal line" width="100%"/>
                </div>
                <div className="pt-3">
                    <h3 className="corporate h3f"><span className="first-letter">T</span>hrive</h3>
                    <p className="p16" >Get access to customer-level data and actionable insights to form new partnerships and audiences.

                    </p>
                    <img src="/assets/images/hrline.png" alt="horizontal line"  title="horizontal line" width="100%"/>
                </div>
                <div className="pt-3">
                    <h3 className="corporate h3f"><span className="first-letter">S</span>ucceed</h3>
                    <p className="p16" >Drive more sales by joining hands with world-className publishers for promoting your products/services.
                    </p>
                    <img src="/assets/images/hrline.png" alt="horizontal line"  title="horizontal line" width="100%"/>
                </div>
            </div>


        </div>
        <div className="row pt-5">
            <div className="col-sm-6 pr-5">
                <h1 className="corporate h2f  t40 "><span className="first-letter">M</span>ore <span className="first-letter">C</span>ontrol for <span className="first-letter">A</span>dvertisers to <span className="first-letter">G</span>row
                    <span className="first-letter">T</span>heir <span className="first-letter">B</span>usinesses</h1>
                <p className="pt-3 text-justify p16">
                    Majority of the Advertisers spend money on popular Social Media and Search Engine platforms because of their popularity; however, Advertisers have limited control while advertising on such digital platforms. We at AiPlex Ads, a team of digital experts,
                    will help Advertisers with customized solutions where you retain all the control. Today’s affiliate landscape has evolved from traditional coupons, loyalty, and blog affiliates to now include social media influencers, business development
                    partners, and even paid media partners. This means, to meet these new changes and challenges, we need dynamic workflows, processes and tools to manage it.
                </p>
            </div>
            <div className="col-sm-6 pl-5">
                
                <img src="/assets/images/aiplex-ads-control-ads.png" alt="More Control for Advertisers to GrowTheir Businesses"  title="More Control for Advertisers to GrowTheir Businesses" className="img_size"/>
            </div>


        </div>

    </div>
</div>
<div className="Banner_BG">
    <div className="Banner_padding1">
        <h2 className="corporate text-center h2f  t40 "><span className="first-letter">W</span>ho <span className="first-letter">A</span>re <span className="first-letter">W</span>e</h2>
        <div className="row pt-5 text-justify">
            <div className="col-sm-6 pr-4">
                <p  className="p16" >
                    An online advertising company that provides access to a global network of marketing & Advertising channels to increase sales, leads, sign-ups, app installs, etc. We help you build your brand in any niche, anywhere. Our global Ad network empowers advertisers
                    and publishers of all sizes to grow their businesses online. You might be a Publisher or an Advertiser; we at AiPlex are consumed with doing everything we can to ensure you reach your full potential as an affiliate marketer.</p>

            </div>
            <div className="col-sm-6 pl-3">
                <p  className="p16" >

                    Create profitable and long-lasting partnerships by promoting products and services to a world-wide audience. Find the right advertisers: Browse the profiles of every advertiser on the network, using the sales regions and industry filters. Get in touch
                    to join and start promoting the brands you love. Get timely payment any time, every time.</p>

            </div>



        </div>
        <div className="row pt-3">
            <div className="col-sm-12"> <img src="/assets/images/aiplex-ads-who-are-we.png" alt="Who are we"  title="Who are we" className="w-100"/></div>

        </div>
    </div>
</div>
<div className="hrline">
</div>

<div className="consult">
    <div className=" bpadding2" style={{paddingBottom:'10px !important', paddingTop:'65px !important'}}>
        <div className="row">
            <div className="col-sm-7">
                <h2><strong>Ready to get started?</strong></h2>
                <h3>Learn how AiPlex Digital can solve <br/>your more complex needs</h3>
            </div>
            <div className="col-sm-3 float-bottom">
                <a className="btn btn-primary1 " href="#contact">Get In Touch</a>
            </div>
        </div>
    </div>
</div>
<div className="hrline"></div>
            </div>
             )
    }
}
Advertisers.propTypes = {
    value: PropTypes.object.isRequired
};
export default Advertisers